// extracted by mini-css-extract-plugin
module.exports = {"container":"PQ","noResults":"QQ","contact":"RQ"};